import React, { useEffect, useState, useRef } from 'react';
import { ChevronDown, ChevronUp } from '@saleshandy/icons';
import { useTranslation } from 'react-i18next';
import { Button } from '@saleshandy/design-system';
import Transfer from '../../../../../shared/design-system/components/transfer';
import { Placement } from '../../../../../shared/design-system/components/overlay/enums';
import Checkbox from '../../../../../shared/design-system/components/atoms/checkbox';
import TruncatedTextWithAutoTooltip from '../../../../../shared/components/truncated-text-with-auto-tooltip';

export type Option = {
  key: string;
  id: number;
  name: string;
};

export interface IProps {
  leadTags: any[];
  leadTagsIds: number[];
  onLeadTagsIdsChange: (tagIds: number[]) => void;
  className?: string;
}

const TagSavedFilters: React.FC<IProps> = ({
  leadTags,
  leadTagsIds,
  onLeadTagsIdsChange,
  className,
}) => {
  const { t } = useTranslation();

  const [selectedLeadTagsIds, setSelectedLeadTagsIds] = useState<number[]>([]);
  const [show, setShow] = useState(false);
  const prevLeadTagsIdsRef = useRef<number[]>([]);

  useEffect(() => {
    // Only update if the actual values changed, not just the reference
    const currentIdsStr = JSON.stringify([...leadTagsIds].sort());
    const prevIdsStr = JSON.stringify([...prevLeadTagsIdsRef.current].sort());
    
    if (currentIdsStr !== prevIdsStr) {
      setSelectedLeadTagsIds([...leadTagsIds]);
      prevLeadTagsIdsRef.current = [...leadTagsIds];
    }
  }, [leadTagsIds]);

  const options: Option[] =
    leadTags?.map((leadTag) => ({
      key: leadTag.id.toString(),
      id: leadTag.id,
      name: leadTag.name,
    })) || [];

  return (
    <Transfer<Option>
      show={show}
      onToggle={(value) => setShow(value)}
      className={`lead-filter-dropdown lead-filter ${className || ''}`}
      showSearch
      searchPlaceholder="Search"
      multiSelect
      options={options}
      showOptionsSeparator={true}
      selectedOptionKey={selectedLeadTagsIds.map((key) => key.toString())}
      optionFilterProp="name"
      filterOption={(value, option) =>
        option?.name?.toLowerCase().includes(value.toLowerCase())
      }
      optionRenderer={(option) => (
        <TruncatedTextWithAutoTooltip text={option?.name} className="sequence-name-item" />
      )}
      onChange={(selectedOptions) => {
        setSelectedLeadTagsIds(
          selectedOptions.map((option) => option.id),
        );
      }}
      placement={Placement.BottomStart}
      footer={
        <>
          <Checkbox
            checked={selectedLeadTagsIds.length === options.length}
            intermediate={selectedLeadTagsIds.length !== 0}
            label={t('labels.select_all')}
            onChange={(checked) => {
              if (checked) {
                setSelectedLeadTagsIds(
                  options.map((option) => parseInt(option.key, 10)),
                );
              } else {
                setSelectedLeadTagsIds([]);
              }
            }}
          />
          <Button
            onClick={() => {
              onLeadTagsIdsChange(selectedLeadTagsIds);
              setShow(false);
            }}
          >
            {t('labels.apply')}
          </Button>
        </>
      }
    >
      <Button
        className="transfer-select-btn btn-white w-1 lead-tags-btn select-saved-tag"
        variant="tertiary"
        onClick={() => setShow(!show)}
      >
        <div className="transfer-select-btn-content">
          <span>Select</span>
        </div>
        <div className="bs-select-box-icon-wrapper">
          {show ? <ChevronUp /> : <ChevronDown />}
        </div>
      </Button>
    </Transfer>
  );
};

export default TagSavedFilters;

